import { lazy } from "solid-js";

// history feature の public surface: 記録・継続日数を見る画面群 (/ , /sessions, /sessions/:id)。
// route 単位の code-splitting 境界をここで決める (feature 内部は外から index.ts 経由でしか触れない)。
export const HomePage = lazy(() => import("./pages/home-page"));
export const SessionsPage = lazy(() => import("./pages/sessions-page"));
export const SessionDetailPage = lazy(() => import("./pages/session-detail-page"));
